<template>
    <div class="login">

        <div class="login_box">
            <el-form class="login-container" label-position="left" label-width="0px"  @keyup.native.enter="login">
                <h3 class="login_title">登录系统管理后台</h3>
                <el-form-item>
                    <el-input type="text" v-model="loginForm.username" auto-complete="off" placeholder="请输入账号"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input type="password" v-model="loginForm.password" auto-complete="off"
                        placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item style="width: 100%;margin-top: 36px">
                    <el-button class="btnred" type="primary" style="width: 100%;" @keyup.enter="login" :loading="loading" :disabled="btnDisabled"
                        v-on:click="login">登录</el-button>
                </el-form-item>

            </el-form>
        </div>

      <el-dialog :visible="agreementShow"
                  width="80%"
                 @close="agreementShow=false"
                 custom-class="agreement_dialog"
                 title="隐私保护协议">
        <div class="agreement_wrap">
         <p>111</p>
        </div>
      </el-dialog>

    </div>
</template>

<script>

import { adminLogin } from '@/api/api'
import { mapState } from 'vuex'
export default {
    name: 'adminLogin',

    data() {
        return {
            btnDisabled:false,
            loginForm: {
                username: '',
                password: '',
                agree:false
            },
            loading: false,
            agreementShow:false,
        }
    },
    computed: {
        ...mapState(['saveAdminUserInfo']),
    },
    created () {
      if(this.adminUserInfo && this.adminUserInfo.token){
        this.$router.replace('/admin/individual_users')
      }
    },
    methods: {
        login() {
            if (!this.loginForm.username) {
                this.$message.error('请输入账号');
                return false
            }
            if (!this.loginForm.password) {
                this.$message.error('请输入密码');
                return false
            }
            this.btnDisabled = true
            adminLogin({
                phone: this.loginForm.username,
                password: this.loginForm.password
            }).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    this.loginSuccess(data)
                  this.btnDisabled = false
                } else {
                  this.btnDisabled = false
                }
            })
        },
            //登录成功
         loginSuccess (res) {
            this.$message.success('登录成功')
            //保存token到vuex中
           this.$store.dispatch('saveAdminUserInfo', res)
           //跳转
           this.$router.replace({name:'individual_users'});
        },
    },
}
</script>

<style scoped lang="scss">
.login {
    width: 100%;
    height: 100vh;
    background-color: rgb(245 246 250);
    background-image: url(https://download.hecoos.com/enlightv/2024-32/Xw6yWsKhfWJ4pifpd4TQ.png);
    background-size: 100% 100%;
}

.login .login_box {
    width: 448px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0 auto;
    padding: 40px;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    border-bottom: none;

}


.login .login_box .login_title {
    width: 100%;
    height: 48px;
    font-size: 24px;
    color: #333;
    line-height: 48px;
    margin-bottom: 22px;
    position: relative;
    font-weight: bold;
  text-align: center;
}
.agree_check_wrap {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.agree_check_wrap .agreement_text {
  line-height: 22px;
  font-size: 14px;
  color: #333333;
  transition: color .3s;
  margin-left: 4px;
}


</style>
